import routes from '@config/routes.json';
import {
    all,
    isAuth,
    isEpn,
    isGlobalDomain,
    isGuest,
    isRu,
    isSelfEmployedAllowed,
    not,
} from '@layout/Header/utils/predicates';

import newIcon from '../components/NavBar/img/new.svg';
import { NavItemDefinition, NavItemId } from '../interfaces';

const oldCabinetLinks = JSON.parse(process.env.NEXT_PUBLIC_OLD_CABINET_LINKS || '{}');

const NAV_CATALOG: Record<NavItemId, NavItemDefinition> = {
    statistic: {
        id: 'statistic',
        labelKey: 'Statistic',
        children: ['statistic.general', 'statistic.transactions'],
        visible: isAuth,
        testIds: {
            navbar: 'NavBarDesktopStatisticDropdown',
            burger: 'MenuMobileStatisticDropdown',
        },
    },
    'statistic.general': {
        id: 'statistic.general',
        labelKey: 'General',
        href: routes.statistics.common,
        visible: isAuth,
        testIds: {
            navbar: 'NavBarDesktopCommonStatsLink',
            burger: 'MenuMobileCommonStatsLink',
        },
    },
    'statistic.transactions': {
        id: 'statistic.transactions',
        labelKey: 'Transactions',
        href: routes.statistics.transactions,
        visible: isAuth,
        testIds: {
            navbar: 'NavBarDesktopTransactionStatsLink',
            burger: 'MenuMobileTransactionStatsLink',
        },
    },
    tools: {
        id: 'tools',
        labelKey: 'Tools',
        href: routes.creatives,
        visible: isAuth,
        testIds: {
            navbar: 'NavBarDesktopToolsLink',
            burger: 'MenuMobileToolsLink',
        },
    },
    trafficSources: {
        id: 'trafficSources',
        labelKey: 'My Traffic Sources',
        href: routes.placements.list,
        visible: isAuth,
        testIds: {
            navbar: 'NavBarDesktopTrafficSourcesLink',
            burger: 'MenuMobileTrafficSourcesLink',
            userMenu: 'ProfileTrafficSourcesLink',
        },
    },
    affiliatePrograms: {
        id: 'affiliatePrograms',
        labelKey: 'Affiliate Programs',
        href: routes.offers,
        testIds: {
            navbar: 'NavbarTabletOffersLink',
            burger: 'MenuMobileOffersLink',
        },
    },
    support: {
        id: 'support',
        labelKey: 'Support',
        href: routes.support.list.replace(':status', 'open'),
        visible: isAuth,
        badge: ctx => ctx.runtime.supportUnreadCount || null,
        testIds: {
            navbar: 'NavBarDesktopSupportLink',
            burger: 'MenuMobileSupportLink',
        },
    },
    faq: {
        id: 'faq',
        labelKey: 'FAQ',
        href: oldCabinetLinks.faq,
        visible: all(isAuth, isEpn),
        testIds: {
            navbar: 'NavbarTabletFaqLink',
            burger: 'MenuMobileFaqLink',
        },
    },
    learning: {
        id: 'learning',
        labelKey: 'Learning',
        href: routes.faq.learning,
        visible: all(isAuth, isEpn, isRu),
        testIds: {
            navbar: 'NavbarTabletLearningLink',
            burger: 'MenuMobileLearningLink',
        },
    },
    crypto: {
        id: 'crypto',
        labelKey: 'Cryptovertical',
        children: ['crypto.webmasters', 'crypto.advertiser'],
        visible: isEpn,
        icon: newIcon,
        testIds: {
            navbar: 'NavBarCryptoVerticalDropdown',
            burger: 'MenuCryptoDropdown',
        },
    },
    'crypto.webmasters': {
        id: 'crypto.webmasters',
        labelKey: 'Webmasters',
        href: routes.crypto,
        visible: isEpn,
        testIds: {
            burger: 'Webmasters',
        },
    },
    'crypto.advertiser': {
        id: 'crypto.advertiser',
        labelKey: 'Advertiser',
        href: routes.cryptoadvertiser,
        visible: isEpn,
        testIds: {
            burger: 'Advertiser',
        },
    },
    webmasters: {
        id: 'webmasters',
        labelKey: 'Webmasters',
        href: routes.home,
        visible: isGuest,
        testIds: {
            navbar: 'MenuDesktopWebmastersLink',
            burger: 'MenuMobileWebmastersDropdownEn',
        },
    },
    advertisers: {
        id: 'advertisers',
        labelKey: 'Advertisers',
        href: routes.cpa,
        visible: isGuest,
        testIds: {
            navbar: 'MenuDesktopAdvertiserLink',
            burger: 'MenuMobileAdvertiserLink',
        },
    },
    help: {
        id: 'help',
        labelKey: 'FAQ',
        href: oldCabinetLinks.faq,
        visible: all(isGuest, isEpn),
        testIds: {
            navbar: 'MenuDesktopHelpLink',
            burger: 'MenuMobileHelpLink',
        },
    },
    profile: {
        id: 'profile',
        labelKey: 'My profile',
        href: routes.profile,
        visible: isAuth,
        testIds: {
            userMenu: 'ProfileMyProfileLink',
        },
    },
    dashboard: {
        id: 'dashboard',
        labelKey: 'Dashboard',
        href: routes.dashboard,
        visible: isAuth,
        testIds: {
            userMenu: 'ProfileDashboardLink',
            burger: 'MenuMobileDashboardLink',
        },
    },
    acts: {
        id: 'acts',
        labelKey: 'Acts',
        href: routes.acts,
        visible: all(isAuth, isSelfEmployedAllowed, not(isGlobalDomain)),
        testIds: {
            userMenu: 'ProfileActsLink',
        },
    },
    logout: {
        id: 'logout',
        labelKey: 'Logout',
        action: 'logout',
        visible: isAuth,
        testIds: {
            userMenu: 'ProfileLogoutButton',
            burger: 'MenuMobileLogout',
        },
    },
};

export default NAV_CATALOG;
